import { useContext, useMemo } from 'react';
import { createApiClient } from './api-client';
import { AuthContext } from '../context/auth-context';
import { getApiBaseUrl } from '../utils/cp-context';

/**
 * Hook that provides a configured axios client for API requests.
 * Automatically includes auth token from context.
 */
export function useApiClient() {
  const { getToken } = useContext(AuthContext);

  return useMemo(() => {
    return createApiClient({
      baseURL: getApiBaseUrl(),
      getAuthToken: getToken,
    });
  }, [getToken]);
}
